import { FunctionComponent, lazy } from 'react';

import { PlantFormStepBasicDetails } from '@/features/plants/components/plant-management/shared/steps/plant-form-step-basic-details.tsx';
import { TechnicalSpecification } from '@/features/plants/components/plant-management/shared/steps/plant-form-step-technical-specifications.tsx';
import { PlantFormStepEquipmentAndConnectionDetails } from '@/features/plants/components/plant-management/shared/steps/plant-form-step-equipment-and-connection-details.tsx';
import { PlantFormStepFinancialInformation } from '@/features/plants/components/plant-management/shared/steps/plant-form-step-financial-information.tsx';

const SiteInformation = lazy(
  () =>
    import(
      '@/features/plants/components/plant-management/shared/steps/plant-form-step-site-information.tsx'
    )
);
const ContactDetails = lazy(
  () =>
    import(
      '@/features/plants/components/plant-management/shared/steps/plant-form-step-contact-details.tsx'
    )
);

type SchemaValue =
  | 'basicDetails'
  | 'siteInformation'
  | 'technicalSpecifications'
  | 'equipmentAndConnectionDetails'
  | 'financialInformation'
  | 'contactDetails'
  | undefined;

type TStep = {
  number: number;
  title: string;
  Element: FunctionComponent<{ showTitle: boolean }>;
  schema?: SchemaValue;
  id: string;
};

export const MAIN_STEPS: TStep[] = [
  {
    number: 1,
    title: 'Basic Details',
    Element: PlantFormStepBasicDetails,
    schema: 'basicDetails',
    id: '#basicDetails',
  },
  {
    number: 2,
    title: 'Site Information',
    Element: SiteInformation,
    schema: 'siteInformation',
    id: '#siteInformation',
  },
  {
    number: 3,
    title: 'Technical Specifications',
    Element: TechnicalSpecification,
    schema: 'technicalSpecifications',
    id: '#technicalSpecifications',
  },
  {
    number: 4,
    title: 'Equipment and connection details',
    Element: PlantFormStepEquipmentAndConnectionDetails,
    schema: 'equipmentAndConnectionDetails',
    id: '#equipmentAndConnectionDetails',
  },
  {
    number: 5,
    title: 'Financial Information',
    Element: PlantFormStepFinancialInformation,
    schema: 'financialInformation',
    id: '#financialInformation',
  },
  {
    number: 6,
    title: 'Contact details',
    Element: ContactDetails,
    schema: 'contactDetails',
    id: '#contactDetails',
  },
];

export const STEPS_EDIT = MAIN_STEPS;
